<template>
  <form @submit.prevent="onLoginAction" method="post" class="user">
    <div
      :class="{ 'd-none': !onErrorMsg }"
      class="alert alert-danger alert-icon"
    >
      <em class="icon ni ni-cross-circle"></em>
      <strong>¡Error de inicio de sesion!</strong>
      <ul>
        <li v-for="(error, index) in arrayErrors" :key="index">{{ error }}</li>
      </ul>
    </div>
    <div class="form-group">
      <input
        type="email"
        class="form-control"
        v-model.trim="$v.form.email.$model"
        :class="{ 'is-invalid':$v.form.email.$error }"
        placeholder="Correo electronico"
      />
       <div class="invalid-feedback">
            <span v-if="!$v.form.email.$required">Este campo es requerido</span>
            <br>
            <span v-if="!$v.form.email.$email">Formato de correo electrónico inválido</span>
        </div>
    </div>

    <button
      :disabled="onLoadForm"
      type="submit"
      class="btn btn-dark btn-block"
    >
      <clip-loader
        :class="{ 'd-none': !onLoadForm }"
        style="display: inline; margin-right: 10px"
        color="#fff"
        size="15px"
      ></clip-loader>
      Enviar
    </button>
  </form>
</template>

<script>
import {required, email} from 'vuelidate/lib/validators';
import axios from "axios";
export default {
  data() {
    return {
      form: {
          email: ''
        },
      onLoadForm: false,
      onErrorMsg: false,
      arrayErrors: [],
    };
  },
  validations: {
      form:{
        email: {
            required,
            email
        },
       
      }
    },
  methods: {
    onLoginAction() {
      this.$v.$touch()
      if(this.$v.$invalid){
          return this.submitStatus = "False";
      }else{
        axios.post("/ajax/email_restablecer", this.form).then((response) => {
          var parseRes = response.data.status;
          if(parseRes != 'success') {
            this.$swal.fire({
              icon: 'error',
              title: 'Recuperacion de contraseña',
              text: '¡El correo electrónico no pertenece a un usuario registrado!',
              confirmButtonColor: '#858796',
              confirmButtonText: 'Ok'
            })
          } else {
            this.$swal.fire({
              icon: 'success',
              title: 'Recuperacion de contraseña',
              text: '¡Recibiras un correo electrónico con los pasos para recuperar tu contraseña!',
              confirmButtonColor: '#858796',
              confirmButtonText: 'Ok'
            }).then((result) => {
              if (result.isConfirmed) {
                window.location.href = "/login";
              }
            })
          }
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
</style>